/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { IProfileModel } from '../../models/account/IProfile.model';

export enum ProfileActionTypes {
  GetProfile = '[Profile] Get Profile',
  GetProfileSuccess = '[Profile] Get Profile Success',
  GetProfileError = '[Profile] Get Profile Error',
  UpdateProfileInit = '[Profile] Update Profile Init',
  UpdateProfileSuccess = '[Profile] Update Profile Success',
  UpdateProfileErrorVersionConflict = '[Profile] Update Profile Error Version Conflict'
}

export class GetProfile implements Action {
  readonly type = ProfileActionTypes.GetProfile;
}

export class GetProfileSuccess implements Action {
  readonly type = ProfileActionTypes.GetProfileSuccess;
  constructor(public payload: IProfileModel) {}
}

export class GetProfileError implements Action {
  readonly type = ProfileActionTypes.GetProfileError;
}

export class UpdateProfileInit implements Action {
  readonly type = ProfileActionTypes.UpdateProfileInit;
  constructor(public payload: IProfileModel) {}
}

export class UpdateProfileSuccess implements Action {
  readonly type = ProfileActionTypes.UpdateProfileSuccess;
  constructor(public payload: boolean) {}
}

export class UpdateProfileErrorVersionConflict implements Action {
  readonly type = ProfileActionTypes.UpdateProfileErrorVersionConflict;
}

export type ProfileActions =
  | GetProfile
  | GetProfileSuccess
  | UpdateProfileErrorVersionConflict
  | GetProfileError
  | UpdateProfileInit
  | UpdateProfileSuccess;
